import { Actor } from '../redux/models'
import classNames from 'classnames'
import { RENDER_CONSTS } from '../config/constants'

type Props = {
    index: number
    actor: Actor

    onEditActor: () => void
    onChangeOrdinal: (dir: "up" | "down") => void
}

export const ActorRow = (props: Props): JSX.Element | null => {

    return (
        // First actor row needs special logic, MUST have a top border
        // Subsequent actor rows MUST NOT have top border

        <div
            style={{
                width: "185px",
                height: RENDER_CONSTS.ROW_HEIGHT,
                background: (props.actor.color ?? undefined)
            }}
            className={classNames(
                "d-flex align-items-center border-dark text-white border",
                { "border-top-0": props.index > 0 },
                { "bg-dark": props.actor.color == null }
            )}
        >
            {(!props.actor.isBoss && !props.actor.hidden) &&
                <div
                    style={{ fontSize: 11 }}
                    className="d-flex align-items-center ms-1 h-100 user-select-none"
                >
                    <div className="cursor-pointer px-1" onClick={() => props.onChangeOrdinal('up')}>
                        {"▲"}
                    </div>
                    <div className="cursor-pointer px-1" onClick={() => props.onChangeOrdinal('down')}>
                        {"▼"}
                    </div>
                </div>
            }

            <div className="w-100 h-100 px-2 cursor-pointer" onClick={props.onEditActor}>
                {props.actor.name}
            </div>
        </div>
    )
}